function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { stringify } from 'query-string';
import { HttpClient } from '../http-client';
export var WidgetType = /*#__PURE__*/ function(WidgetType) {
    WidgetType["CustomCard"] = "CUSTOM_CARD";
    WidgetType["CustomChart"] = "CUSTOM_CHART";
    WidgetType["CustomTable"] = "CUSTOM_TABLE";
    /**
   * @deprecated Not in use
   */ WidgetType["InferredProgressByProjectOwner"] = "INFERRED_PROGRESS_BY_PROJECT_OWNER";
    /**
   * @deprecated Not in use
   */ WidgetType["ProjectByInferredProgress"] = "PROJECT_BY_INFERRED_PROGRESS";
    /**
   * @deprecated Not in use
   */ WidgetType["InferredProgressByTemplate"] = "INFERRED_PROGRESS_BY_TEMPLATE";
    WidgetType["TaskByStatus"] = "TASK_BY_STATUS";
    WidgetType["StatusByPhase"] = "STATUS_BY_PHASE";
    WidgetType["ProjectByStatus"] = "PROJECT_BY_STATUS";
    WidgetType["ProjectCount"] = "PROJECT_COUNT";
    WidgetType["ARR"] = "TOTAL_ARR";
    WidgetType["TitleSection"] = "TITLE_SECTION";
    return WidgetType;
}({});
export const NumberWidgetTypes = [
    "TOTAL_ARR",
    "PROJECT_COUNT",
    "CUSTOM_CARD",
    "TITLE_SECTION"
];
export var WidgetDefaultNumberFields = /*#__PURE__*/ function(WidgetDefaultNumberFields) {
    WidgetDefaultNumberFields["ProjectCount"] = "project_count";
    WidgetDefaultNumberFields["CustomerCount"] = "company_count";
    WidgetDefaultNumberFields["CSAT"] = "csat";
    WidgetDefaultNumberFields["BudgetedHours"] = "budgeted_hours";
    WidgetDefaultNumberFields["ProjectHours"] = "project_hours";
    WidgetDefaultNumberFields["RemainingMinutes"] = "remaining_minutes";
    return WidgetDefaultNumberFields;
}({});
export var WidgetNativeNumberFields = /*#__PURE__*/ function(WidgetNativeNumberFields) {
    WidgetNativeNumberFields["ARR"] = "annualizedRecurringRevenue";
    WidgetNativeNumberFields["ProjectFee"] = "projectFee";
    return WidgetNativeNumberFields;
}({});
export var WidgetNativeValues = /*#__PURE__*/ function(WidgetNativeValues) {
    WidgetNativeValues["ARR"] = "arr";
    WidgetNativeValues["ProjectFee"] = "project_fee";
    return WidgetNativeValues;
}({});
export var FieldClass = /*#__PURE__*/ function(FieldClass) {
    FieldClass["NativeField"] = "NATIVE";
    FieldClass["CustomField"] = "CUSTOM";
    FieldClass["DefaultField"] = "DEFAULT";
    return FieldClass;
}({});
export var UnitPosition = /*#__PURE__*/ function(UnitPosition) {
    UnitPosition["Prefix"] = "PREFIX";
    UnitPosition["Suffix"] = "SUFFIX";
    return UnitPosition;
}({});
export var AggregateType = /*#__PURE__*/ function(AggregateType) {
    AggregateType["Total"] = "SUM";
    AggregateType["Average"] = "AVG";
    AggregateType["Count"] = "COUNT";
    AggregateType["None"] = "NONE";
    return AggregateType;
}({});
export var VerticalAxisDefaultTaskFields = /*#__PURE__*/ function(VerticalAxisDefaultTaskFields) {
    VerticalAxisDefaultTaskFields["TaskCount"] = "count";
    VerticalAxisDefaultTaskFields["TaskCSAT"] = "csat";
    VerticalAxisDefaultTaskFields["TaskTrackedMinutes"] = "trackedMinutes";
    VerticalAxisDefaultTaskFields["TaskEffort"] = "effort";
    VerticalAxisDefaultTaskFields["TaskProgress"] = "progress";
    return VerticalAxisDefaultTaskFields;
}({});
export var VerticalAxisDefaultProjectFields = /*#__PURE__*/ function(VerticalAxisDefaultProjectFields) {
    VerticalAxisDefaultProjectFields["ProjectCount"] = "count";
    VerticalAxisDefaultProjectFields["CSAT"] = "csat";
    VerticalAxisDefaultProjectFields["ProjectBugetedHours"] = "budgetedHours";
    VerticalAxisDefaultProjectFields["ProjectTrackedMinutes"] = "trackedMinutes";
    VerticalAxisDefaultProjectFields["ProjectAge"] = "projectAge";
    VerticalAxisDefaultProjectFields["ProjectRemainingMinutes"] = "remainingMinutes";
    return VerticalAxisDefaultProjectFields;
}({});
export var HorizontalAxisDefaultTaskFields = /*#__PURE__*/ function(HorizontalAxisDefaultTaskFields) {
    HorizontalAxisDefaultTaskFields["TaskStartDate"] = "startDate";
    HorizontalAxisDefaultTaskFields["TaskDueDate"] = "dueDate";
    HorizontalAxisDefaultTaskFields["TaskActualStartDate"] = "actualStartDate";
    HorizontalAxisDefaultTaskFields["TaskActualDueDate"] = "actualDueDate";
    HorizontalAxisDefaultTaskFields["TaskStatus"] = "status";
    HorizontalAxisDefaultTaskFields["TaskAssignee"] = "taskAssignee";
    return HorizontalAxisDefaultTaskFields;
}({});
export var HorizontalAxisDefaultProjectFields = /*#__PURE__*/ function(HorizontalAxisDefaultProjectFields) {
    HorizontalAxisDefaultProjectFields["ProjectStatus"] = "status";
    HorizontalAxisDefaultProjectFields["Templates"] = "template";
    HorizontalAxisDefaultProjectFields["ProjectCreatedDate"] = "createdDate";
    HorizontalAxisDefaultProjectFields["ProjectStartDate"] = "startDate";
    HorizontalAxisDefaultProjectFields["ProjectDueDate"] = "dueDate";
    HorizontalAxisDefaultProjectFields["ActualProjectStartDate"] = "actualStartDate";
    HorizontalAxisDefaultProjectFields["ActualProjectCompletionDate"] = "actualDueDate";
    HorizontalAxisDefaultProjectFields["ProjectOwner"] = "projectOwner";
    return HorizontalAxisDefaultProjectFields;
}({});
export const NativeDateFields = [
    "createdDate",
    "startDate",
    "dueDate",
    "actualStartDate",
    "actualDueDate",
    "dueDate",
    "startDate",
    "actualDueDate",
    "actualStartDate"
];
export const excludedTaskFieldsForCustomChart = [
    'priority'
];
export var WidgetSourceType = /*#__PURE__*/ function(WidgetSourceType) {
    WidgetSourceType["Company"] = "COMPANY";
    return WidgetSourceType;
}({});
export var GroupByDefaultProjectFields = /*#__PURE__*/ function(GroupByDefaultProjectFields) {
    GroupByDefaultProjectFields["ProjectOwner"] = "projectOwner";
    GroupByDefaultProjectFields["ProjectStatus"] = "status";
    return GroupByDefaultProjectFields;
}({});
export var GroupByDefaultTaskFields = /*#__PURE__*/ function(GroupByDefaultTaskFields) {
    GroupByDefaultTaskFields["TaskStatus"] = "status";
    return GroupByDefaultTaskFields;
}({});
export var ZoomLevel = /*#__PURE__*/ function(ZoomLevel) {
    ZoomLevel["Daily"] = "DAY";
    ZoomLevel["Weekly"] = "WEEK";
    ZoomLevel["Monthly"] = "MONTH";
    ZoomLevel["Yearly"] = "YEAR";
    return ZoomLevel;
}({});
export var CustomCardDateType = /*#__PURE__*/ function(CustomCardDateType) {
    CustomCardDateType["Summary"] = "SUMMARY";
    CustomCardDateType["Number"] = "NUMBER";
    CustomCardDateType["Date"] = "DATE";
    CustomCardDateType["User"] = "USER";
    CustomCardDateType["Value"] = "VALUE";
    return CustomCardDateType;
}({});
export var DrillDownExportType = /*#__PURE__*/ function(DrillDownExportType) {
    DrillDownExportType["PROJECT"] = "PROJECT";
    DrillDownExportType["TASK"] = "TASK";
    return DrillDownExportType;
}({});
const RESOURCE_URL = '/widgets';
class WidgetHttpClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "create", (payload, isV2 = false)=>{
            return this.post(`${RESOURCE_URL}${isV2 ? '?useV2=true' : ''}`, payload);
        }), _define_property(this, "editWidget", (widgetId, payload)=>{
            return this.put(`${RESOURCE_URL}/${widgetId}`, payload);
        }), _define_property(this, "previewWidget", (payload)=>{
            return this.post(`${RESOURCE_URL}/preview-widget`, payload);
        }), _define_property(this, "previewWidgetV1", (payload)=>{
            return this.post(`${RESOURCE_URL}/preview-widget-v1`, payload);
        }), _define_property(this, "getWidget", (widgetId)=>{
            return this.get(`${RESOURCE_URL}/${widgetId}`);
        }), _define_property(this, "resolveMultipleWidgets", (dashboardId, widgetIds = [], simpleSearchFilter = null)=>{
            return this.post(`${RESOURCE_URL}/resolve-widgets`, {
                dashboardId: Number(dashboardId),
                ...simpleSearchFilter ? {
                    simpleSearchFilter
                } : {},
                ...widgetIds.length ? {
                    widgetIds
                } : {}
            });
        }), _define_property(this, "resolveMultipleWidgetsV1", (payload)=>{
            return this.post(`${RESOURCE_URL}/resolve-widgets-v1`, {
                simpleSearchFilter: payload.simpleSearchFilter,
                timePeriodFilter: payload.timeRangeFilter,
                sortOrder: payload.sortOrder,
                widgetIds: payload.widgetIds
            });
        }), _define_property(this, "resolveMultipleWidgetsV2", (payload)=>{
            return this.post(`${RESOURCE_URL}/resolve-widgets-v2`, {
                simpleSearchFilter: payload.simpleSearchFilter,
                timePeriodFilter: payload.timeRangeFilter,
                sortOrder: payload.sortOrder,
                widgetIds: payload.widgetIds
            });
        }), _define_property(this, "updateWidgetOrder", (dashboardId, widgetOrderDetailsList)=>this.put(`${RESOURCE_URL}/update-order`, {
                dashboardId,
                widgetOrderDetailsList
            })), _define_property(this, "updateWidgetOrderBySourceId", (sourceType, widgetOrderDetailsList)=>this.put(`${RESOURCE_URL}/update-order`, {
                entitySource: {
                    sourceType
                },
                widgetOrderDetailsList
            })), _define_property(this, "deleteWidget", (widgetId)=>{
            return this.delete(`${RESOURCE_URL}/${widgetId}`);
        }), _define_property(this, "resolveWidget", (widgetId)=>{
            return this.get(`${RESOURCE_URL}/${widgetId}/resolve-widget`);
        }), _define_property(this, "drillWidget", (widgetId, payload)=>{
            return this.post(`${RESOURCE_URL}/${widgetId}/drill-widget?lite=true`, payload);
        }), _define_property(this, "drillWidgetV2", (widgetId, payload)=>{
            return this.post(`${RESOURCE_URL}/${widgetId}/drill-down-items?lite=true`, payload);
        }), _define_property(this, "drillDownExport", (widgetId, payload)=>{
            return this.post(`${RESOURCE_URL}/${widgetId}/drill-down-items/export`, payload);
        }), _define_property(this, "getDrillDownColumnOrder", (widgetId)=>{
            return this.get(`${RESOURCE_URL}/${widgetId}/drill-down-column-order`);
        }), _define_property(this, "getWidgetsBySource", (sourceType)=>{
            return this.get(`${RESOURCE_URL}?${stringify({
                sourceType
            })}`);
        });
    }
}
export const WidgetAPI = new WidgetHttpClient();
